import * as React from 'react';
import createSvgIcon from './utils/createSvgIcon';
export default createSvgIcon( /*#__PURE__*/React.createElement("path", {
  d: "M3 19h18v-6H3v6zm0-8h18V9H3v2zm0-6v2h18V5H3z"
}), 'HorizontalSplit');


//////////////////
// WEBPACK FOOTER
// ./~/@material-ui/icons/esm/HorizontalSplit.js
// module id = 4155
// module chunks = 2